/* LA PLANQUE — sélecteur de variantes (couleur, taille, matière…).
   Générique : il suit les options déclarées dans l'admin, quel qu'en soit le nombre.
   chrome.js lit data-variant-id sur le bouton au moment du clic :
   tout ce qu'on a à faire, c'est le tenir à jour quand le choix change. */
(function () {
  "use strict";

  function init(picker) {
    var raw = picker.querySelector("[data-vp-data]");
    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw.textContent);
    } catch (e) {
      return;
    }
    if (!data.variants || !data.variants.length) return;

    var box = picker.closest("[data-vp-scope]") || picker.parentNode;
    var btn = box.querySelector(".btn-add");
    var idInput = box.querySelector('input[name="id"]');
    var priceEl = box.querySelector("[data-vp-price]");
    var imgEl = box.querySelector("#fImg, .univers-media img, [data-vp-image]");
    var thumbs = box.querySelector("#fThumbs");
    var isFiche = !!box.querySelector('form[action*="/cart/add"]');

    var current = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === data.current) current = data.variants[i];
    }
    if (!current) current = data.variants[0];

    var chosen = current.options.slice();

    /* la variante qui colle exactement à une combinaison donnée */
    function variantFor(combo) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) {
          return o === combo[i];
        });
      })[0];
    }

    function paintSwatches() {
      picker.querySelectorAll(".vp-swatch").forEach(function (s) {
        var idx = Number(s.dataset.vpIndex);
        var val = s.dataset.vpValue;
        var on = chosen[idx] === val;

        s.classList.toggle("active", on);
        s.setAttribute("aria-checked", on ? "true" : "false");

        /* on dit la vérité sur le stock : cette valeur, combinée au reste du
           choix courant, mène-t-elle à une variante réellement disponible ? */
        var probe = chosen.slice();
        probe[idx] = val;
        var exact = variantFor(probe);
        s.classList.toggle("vp-swatch--off", !exact || !exact.available);
      });

      picker.querySelectorAll(".vp-option").forEach(function (opt) {
        var label = opt.querySelector("[data-vp-current]");
        if (label) label.textContent = chosen[Number(opt.dataset.vpIndex)];
      });
    }

    /* la vignette correspondant à la photo de la variante devient active */
    function syncThumbs(src) {
      if (!thumbs || !src) return;
      var key = src.split("?")[0];
      thumbs.querySelectorAll(".fiche-thumb").forEach(function (t) {
        t.classList.toggle("active", (t.dataset.src || "").split("?")[0] === key);
      });
    }

    function apply(variant) {
      paintSwatches();

      if (!variant) {
        if (btn) {
          btn.disabled = true;
          btn.textContent = "Combinaison indisponible";
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (btn) {
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;
        btn.classList.remove("added");
        btn.innerHTML = variant.available
          ? 'Ajouter au panier <span class="seal">→</span>'
          : "Bientôt de retour";
      }

      if (priceEl) {
        priceEl.innerHTML =
          variant.compareAt && variant.compareAt > variant.price
            ? '<span class="old">' + variant.compareAtLabel + "</span>" + variant.priceLabel
            : variant.priceLabel;
      }

      /* la photo ne bouge que si la variante en porte une :
         changer de taille ne doit pas vider l'image de la couleur choisie */
      if (imgEl && variant.image) {
        imgEl.removeAttribute("srcset");
        imgEl.removeAttribute("sizes");
        imgEl.src = variant.image;
        syncThumbs(variant.image);
      }

      /* sur la fiche, l'URL porte la variante : un partage ou un F5 garde le choix */
      if (isFiche && window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", u);
      }
    }

    picker.addEventListener("click", function (e) {
      var s = e.target.closest(".vp-swatch");
      if (!s) return;
      e.preventDefault();

      var idx = Number(s.dataset.vpIndex);
      chosen[idx] = s.dataset.vpValue;

      var found = variantFor(chosen);
      if (!found) {
        /* la combinaison n'existe pas (Noir en XL jamais fabriqué, par ex.) :
           on garde ce qui vient d'être cliqué et on réaligne le reste sur la
           première variante dispo qui le contient. Jamais de cul-de-sac. */
        var withValue = data.variants.filter(function (v) {
          return v.options[idx] === chosen[idx];
        });
        var fallback = withValue.filter(function (v) {
          return v.available;
        })[0] || withValue[0];
        if (fallback) {
          chosen = fallback.options.slice();
          found = fallback;
        }
      }

      apply(found);
    });

    apply(current);
  }

  function boot() {
    document.querySelectorAll("[data-variant-picker]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
